import { DOMAIN_LIST, OFFICEWORKS_STORE_LIST, ZIPCODES_LIST } from "./ZipCode.action";

const intailreducer = {
  zipCodesList: [],
  domainList: [],
  officeworksStoreList: [],
};

export const zipCodeReducer = (state = intailreducer, action) => {
  switch (action.type) {
    case ZIPCODES_LIST:
      return { ...state, zipCodesList: action.value };
    case DOMAIN_LIST:
      return { ...state, domainList: action.value };
    case OFFICEWORKS_STORE_LIST:
      return { ...state, officeworksStoreList: action.value };

    default:
      return state;
  }
};
